import { render, staticRenderFns } from "./LayoutEditorVerticalNav.vue?vue&type=template&id=5a775560&scoped=true"
import script from "./LayoutEditorVerticalNav.vue?vue&type=script&lang=js"
export * from "./LayoutEditorVerticalNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutEditorVerticalNav.vue?vue&type=style&index=0&id=5a775560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a775560",
  null
  
)

export default component.exports